import styled from "styled-components";

export const ReportContainer = styled.div`
  margin: 4rem 0px 12rem;
  padding: 0px 8px;
  @media screen and (max-width: 786px) {
    margin: 2rem 0px 12rem;
  }
  .no-report-image {
    margin-top: 2.5rem;
    @media screen and (max-width: 786px) {
      width: 340px;
    }
  }
`;
